import { joiResolver } from "@hookform/resolvers/joi";
import Joi from "joi";
import type { FC } from "react";
import { FormProvider, type SubmitHandler, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { ButtonUI } from "../../components/Button";
import { InputUI } from "../../components/rhfs/Input";
import type { SignInInput } from "./index";

type SignInPageProps = {
  onSignIn: SubmitHandler<SignInInput>;
};

export const SignInPage: FC<SignInPageProps> = ({ onSignIn }) => {
  const schema = Joi.object({
    email: Joi.string().required().messages({
      "string.empty": "メールアドレスは必須項目です",
    }),
    password: Joi.string().required().messages({
      "string.empty": "パスワードは必須項目です",
    }),
  });
  const methods = useForm<SignInInput>({
    resolver: joiResolver(schema),
  });
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center px-4 py-8">
      {/* Logo Section */}
      <div className="mb-4">
        <img
          className="w-full max-w-md h-auto drop-shadow-lg -translate-x-4"
          src={`${process.env.PUBLIC_URL}/images/strix_search_top_logo1.png`}
          alt="Strix Search"
        />
      </div>

      {/* Form Section */}
      <div className="w-full max-w-sm">
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSignIn)}>
            <div className="card shadow-2xl bg-white/80 backdrop-blur-sm border border-gray-200/50">
              <div className="card-body">
                <h2 className="text-center text-lg font-semibold text-gray-700 mb-4">
                  ログイン
                </h2>
                <div className="form-control">
                  <InputUI
                    label="メールアドレス"
                    registerName="email"
                    name="email"
                    placeholder="メールアドレスを入力してください"
                    data-testid="signin-page-username"
                  />
                </div>
                <div className="form-control">
                  <InputUI
                    label="パスワード"
                    name="password"
                    registerName="password"
                    type="password"
                    placeholder="パスワードを入力してください"
                    data-testid="signin-page-password"
                  />
                </div>
                <div className="form-control mt-6 mb-1.5">
                  <ButtonUI
                    type="submit"
                    data-testid="signin-page-signin"
                    color="primary"
                    size="n"
                    className="w-full"
                  >
                    ログイン
                  </ButtonUI>
                </div>
                <p className="text-right text-xs label-text-alt">
                  パスワードをお忘れの方は
                  <Link
                    to="/reset-pass-word"
                    data-testid="signin-page-to-reset-pass-word"
                    className="link link-primary"
                  >
                    こちら
                  </Link>
                </p>
                <p className="text-right text-xs label-text-alt">
                  新規登録は
                  <Link
                    to="/signup"
                    data-testid="signin-page-to-signup"
                    className="link link-primary"
                  >
                    こちら
                  </Link>
                </p>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
